// An interaction made by a user
export const trackingInteractions = {
  DOWNLOAD_INVOICE: 'download+invoice',
};

// A visual experience presented to the user
export const trackingViews = {
  PAY_INVOICES: {
    currentPage: 'pay invoices',
    siteSection: 'account settings',
    siteSubSection: 'invoices',
    actionOrigin: 'invoice',
  },
  PAYABLE_INVOICES: {
    currentPage: 'payable invoices',
    siteSection: 'account settings',
    siteSubSection: 'invoices',
  },
  INVOICE_HISTORY: {
    currentPage: 'invoice history',
    siteSection: 'account settings',
    siteSubSection: 'invoices',
  },
};

// Refering to an event that has happened but has not yet been reported
// Events should be past tense
export const trackingEvents = {
  BACK_TO_SELECT_INVOICES_PRESSED: 'back_to_select_invoices_pressed',
  MORE_INVOICES_PRESSED: 'more_invoices_pressed',
  INVOICE_DOWNLOADED_PRESSED: 'invoice_downloaded_pressed',
  PAYABLE_INVOICES_DISPLAYED: 'payable_invoices_displayed',
  PAY_INVOICES_DISPLAYED: 'pay_invoices_displayed',
  PAY_INVOICES_SUCCESS_DISPLAYED: 'pay_invoices_success_displayed',
  INVOICE_HISTORY_DISPLAYED: 'invoice_history_displayed',
  EXPANDED_EFTPOS_DETAILS_PRESSED: 'expanded_eftpos_details_pressed',
  CONTINUE_TO_INVOICE_HISTORY_PRESSED: 'continue_to_invoice_history_pressed',
  CONTINUE_TO_PAY_PRESSED: 'continue_to_pay_pressed',
  PAID_FOR_PARTIAL_INVOICE: 'paid-for-partial-invoice',
  PAY_INVOICE_BY_VA_SUCCESS_DISPLAYED: 'pay_invoice_by_va_success_displayed',
};
